import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps } from "@client/controls/Form/component";
import { connectCustom } from "@client/lib/misc";
import { type AppState, Status } from "@client/types";
import { login } from "../actions";
import Component, { type ActionProps, type MapProps } from "../Button/component";
import { localStateSelector } from "../selectors";
import { type LoginForm } from "../types";

type Props = RootContainerProps &
  FormButtonProps & {
    isLogin: boolean;
  };
const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      isDisabled: !localState.canLogin || localState.status === Status.Saving
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClick: (data: LoginForm.View.LoginFormData) => dispatch(login({ id: props.id, source: props.source }, data))
});

const LoginButton = connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);

export default LoginButton;
